import React, { useEffect, useState } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  Button,
  UncontrolledTooltip,
  Progress,
} from "reactstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Table, Label } from "reactstrap";
import parentsModal from "models/parents.modal";
import AttendanceModel from "models/Attendance.modal";
import { helper } from "lib/helper";
import AdditionalProduntDetails from "./AdditionalProduntDetails";
import AttendanceOverview from "./AttendanceOverview";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import creditMappingModel from "models/creditMapping.model";
import Loader from "components/loader/Loader";
import { generateRandomStrings } from "lib/helper";
import financemanagementModal from "models/financemanagement.modal";
import moment from "moment";

const ViewCreditMapping = () => {
  const [activeTab, setActiveTab] = useState("Basicdetails");
  const navigation = useNavigate();

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };
  const getTabContentStyle = (tabId) => {
    return {
      display: activeTab === tabId ? "block" : "none",
      transition: "height 0.3s ease-in-out",
      overflow: "hidden",
    };
  };

  const [dataList, setDataList] = useState([]);
  const [invvoiceList, setInvoiceList] = useState([]);
  const [invTableLoading, setInvTableLoading] = useState(true);
  const [isDataFetched, setIsDataFetched] = useState(generateRandomStrings(15));
  const [isLoading, setIsLoading] = useState(false);
  const [attendanceList, setAttendanceList] = useState([]);
  const [isAttendanceLoading, setAttendanceIsLoading] = useState(false);
  const location = useLocation();
  const params = useParams();

  const getInvoiceList = async () => {
    if (dataList?.data?.id) {
      setInvTableLoading(true);
      const query = {
        class_id: dataList?.data?.id,
      };
      await financemanagementModal
        .listofInvoice(query)
        .then((response) => {
          //console.log("invoicde list ----------- ", response?.data);
          setInvoiceList(response?.data?.data);
          setInvTableLoading(false);
        })
        .catch((error) => {
          console.log("invoice list error", error);
        });
    }
  };

  const getAttendanceList = async () => {
    if (dataList?.data?.lastClassCycle?.id && params?.id) {
      setAttendanceIsLoading(true);

      await AttendanceModel.GetAllAttendanceList(
        dataList?.data?.id,
        dataList?.data?.lastClassCycle?.id,
        "regular"
      )
        .then((result) => {
          if (result) {
            setAttendanceIsLoading(false);
            setAttendanceList(result?.data?.data);
          }
        })
        .catch((error) => {
          // helper.sweetalert.toast(error.response?.data?.message, "warning");
        });
    }
  };

  const getListData = async () => {
    setIsLoading(true);
    try {
      const result = await creditMappingModel.Detail(params?.id);
      if (result) {
        console.log("Data ------------------------> ", result);
        setDataList(result);
        console.log("data result ---------------------->", dataList?.data);
        if (result?.data?.discount_price != null) {
          setTotalPrice(result?.data?.discount_price);
        } else if (
          result?.data?.number_of_session &&
          result?.data?.price_parent
        ) {
          const total_price = Math.floor(
            result?.data?.number_of_session * result?.data?.price_parent
          );
          setTotalPrice(total_price);
        }
        setIsDataFetched(generateRandomStrings(15));
      }
    } catch (error) {
      // helper.sweetalert.toast(error?.response?.data?.message, "warning");
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getListData();
  }, [location, params?.id]);

  const [totalPrice, setTotalPrice] = useState(0);
  const [amountConsumed, setAmountConsumed] = useState(0);
  const [amountRemaining, setAmountRemaining] = useState(0);
  const [consumedPercent, setConsumedPercent] = useState(0);
  useEffect(() => {
    const totalAmount = attendanceList.reduce((sum, item) => {
      const fee = parseFloat(item.fees_for_parent) || 0;
      return sum + fee;
    }, 0);
    setAmountConsumed(parseFloat(totalAmount.toFixed(2)));
    setAmountRemaining(parseFloat((totalPrice - totalAmount).toFixed(2)));
    if (totalPrice > 0) {
      const percentage = Math.floor((totalAmount / totalPrice) * 100);
      if (percentage > 100) {
        setConsumedPercent(100);
      } else {
        setConsumedPercent(percentage);
      }
    } else {
      setConsumedPercent(0);
    }
  }, [attendanceList, totalPrice]);

  useEffect(() => {
    const fetchStudentSubjects = async () => {
      if (dataList?.data?.studentData) {
        const updatedDataList = { ...dataList };
        const studentDataPromises = updatedDataList.data.studentData.map(
          async (studentItem) => {
            const studentSubjects = await parentsModal.StudentSubjectList(
              studentItem?.id
            );
            return {
              ...studentItem,
              subjectList: studentSubjects?.data?.Subjects || [],
            };
          }
        );

        const updatedStudentData = await Promise.all(studentDataPromises);
        updatedDataList.data.studentData = updatedStudentData;
        setDataList(updatedDataList);
      }
    };
    getAttendanceList();
    fetchStudentSubjects();
    getInvoiceList();
  }, [isDataFetched]);

  const [cycledata, setCycledata] = useState();
  const GetAllCycle = async () => {
    AttendanceModel.getcycle(params?.id)
      .then((responce) => {
        setCycledata(responce?.data?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  useEffect(() => {
    if (params?.mid) {
      GetAllCycle();
    }
  }, [location]);

  console.log("mmmmmmtttt", dataList);
  const consumedPercents = Math.round(
    (amountConsumed / dataList?.data?.monthly_fee) * 100
  );
  return (
    <>
      {dataList?.data ? (
        <Container className=" py-7">
          <Card className="shadow mt-1">
            <CardBody className="p-1">
              {isLoading ? (
                <Loader />
              ) : (
                <div className="container ">
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <Row>
                      <Col
                        md={12}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "row",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          Class Status -
                        </span>

                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "bold",
                            color: "white",
                            backgroundColor: "green",
                            borderRadius: "10px",
                            marginLeft: "10px",
                            padding: "5px",
                          }}
                        >
                          {" "}
                          Active
                        </span>
                      </Col>
                    </Row>

                    <Row className="mt-3 ml-5">
                      <Col md={12}>
                        <Label
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          Tutors Name - {dataList?.data?.tutorData?.first_name}{" "}
                        </Label>
                      </Col>
                    </Row>
                    <Row className=" ml-5 align-item-center">
                      <Label
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          marginTop: "16px",
                        }}
                      >
                        Cycle
                      </Label>
                      <select
                        className="px-4 ml-2 mt-2 rounded py-1"
                        defaultValue={params?.mid}
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          if (params?.id && selectedValue) {
                            navigation(
                              `/admin/creditmapping/creditmapping-view/${params.id}/${selectedValue}`
                            );
                          }
                        }}
                      >
                        {cycledata?.map((item, index) => {
                          return <option value={item?.id}>{index + 1}</option>;
                        })}
                      </select>
                    </Row>
                  </div>

                  {/* <div > */}
                  <div
                    className="col-12  px-0"
                    id="v-pills-tabContent"
                    style={{}}
                  >
                    <div className="mt-2">
                      {/* <CreditMappingEnqueryDetails/> */}
                      <Row>
                        <div className="col mt-3">
                          <Card className="shadow">
                            <CardHeader className="border-0 d-flex justify-content-between ">
                              <h3 className="mb-0">Students List</h3>
                            </CardHeader>

                            <Table
                              className="align-items-center table-flush"
                              responsive
                            >
                              <thead className="thead-light">
                                <tr>
                                  <th scope="col">S.No.</th>
                                  <th scope="col">Student NAME</th>
                                  <th scope="col">Subject</th>

                                  <th scope="col">Gender</th>
                                  <th scope="col">Date of Birth</th>
                                  <th scope="col">
                                    {" "}
                                    School/College/University Name
                                  </th>
                                  <th scope="col">Preferred Time</th>
                                  <th scope="col">Tuition Tenure</th>
                                  <th scope="col">Location Preference</th>
                                  {/* <th scope="col"> Enquiry For</th> */}
                                  <th scope="col"> Loaction City</th>
                                  <th scope="col"> Tutors Level</th>
                                  {/* <th scope="col">Action</th>*/}
                                </tr>
                              </thead>

                              {dataList?.data?.studentData && (
                                <tbody>
                                  {dataList?.data?.studentData?.map(
                                    (studentItem, studentIndex) => {
                                      return (
                                        <tr key={`student${studentIndex}`}>
                                          <td>{studentIndex + 1}</td>
                                          <td>{studentItem?.name}</td>
                                          <td>
                                            {studentItem?.subjectList?.[0]?.data?.map(
                                              (subjectItem, subjectIndex) => {
                                                return (
                                                  <span
                                                    key={`subjectItem${subjectIndex}`}
                                                  >
                                                    {subjectIndex > 0 ? (
                                                      <>
                                                        <br />
                                                      </>
                                                    ) : (
                                                      ""
                                                    )}
                                                    <span>
                                                      <b>
                                                        {subjectItem?.title}
                                                      </b>{" "}
                                                      : {subjectItem?.name}
                                                    </span>
                                                  </span>
                                                );
                                              }
                                            )}
                                          </td>
                                          <td>{studentItem?.gender}</td>
                                          <td>{studentItem?.dob}</td>
                                          <td>{studentItem?.school_name}</td>
                                          <td>{studentItem?.preferrd_time}</td>
                                          <td>{studentItem?.term}</td>
                                          <td>{studentItem?.location}</td>
                                          <td>{studentItem?.city}</td>
                                          <td>
                                            {studentItem?.tutor_level_id?.name}
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </tbody>
                              )}
                            </Table>
                          </Card>
                        </div>
                      </Row>

                      <Container className="mt-4">
                        <Row className="border p-3">
                          <Col xs="8">
                            <h3 className="mb-3">Package</h3>
                            <Row className="mb-2">
                              <Col xs="6">
                                <div>Fee Charge per hour</div>
                              </Col>
                              <Col xs="6">
                                <div>₹ {dataList?.data?.hourly_fee}</div>
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col xs="6">
                                <div>Tutor Salary</div>
                              </Col>
                              <Col xs="6">
                                <div>₹ {dataList?.data?.hourly_payscale}</div>
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col xs="6">
                                <div>Monthly</div>
                              </Col>
                              <Col xs="3">
                                <div>Charge</div>
                              </Col>
                              <Col xs="3">
                                <div>Pay</div>
                              </Col>
                            </Row>
                            <Row className="mb-2">
                              <Col xs="6"></Col>
                              <Col xs="3">
                                <div>{dataList?.data?.monthly_fee}</div>
                              </Col>
                              <Col xs="3">
                                <div>{dataList?.data?.monthly_payscale}</div>
                              </Col>
                            </Row>
                            <div className="mt-2">
                              <strong>
                                Tutors Name -{" "}
                                {dataList?.data?.tutorData?.first_name}{" "}
                                {dataList?.data?.tutorData?.last_name}
                              </strong>
                            </div>
                          </Col>
                          <Col xs="4">
                            <div className="mb-2">Sessions a week</div>
                            <div className="mb-3">
                              {dataList?.data?.session_per_month / 4} sessions |{" "}
                              {dataList?.data?.hours / 4} hour
                            </div>
                            <div className="mb-2">Sessions in a month</div>
                            <div className="mb-3">
                              {dataList?.data?.session_per_month} sessions / {" "}
                              {dataList?.data?.hours} {" "}
                              hour
                            </div>
                          </Col>
                        </Row>
                      </Container>
                    </div>
                    {/* <div className="mt-2">
                  <AdditionalProduntDetails creditData={dataList} />
                </div> */}
                    <div className="mt-2">
                      <AttendanceOverview creditData={dataList} />
                    </div>

                    <div className="mt-2">
                      <Container className="mt-5">
                        <Row>
                          <Col md="6" className="text-center">
                            <div
                              style={{
                                width: 200,
                                height: 200,
                                margin: "0 auto",
                              }}
                            >
                              <CircularProgressbar
                                value={consumedPercents}
                                text={`${consumedPercents}%`}
                                styles={buildStyles({
                                  pathColor: "#1e90ff",
                                  textColor: "#000",
                                  trailColor: "#d6d6d6",
                                  backgroundColor: "#3e98c7",
                                  textSize: "8px",
                                })}
                              />
                            </div>
                            <div className="mt-3">
                              <strong>
                                ₹ {amountConsumed} /{" "}
                                {dataList?.data?.monthly_fee}
                              </strong>
                            </div>
                          </Col>
                          <Col md="6">
                            <h3>Credit Counter</h3>
                            <Table bordered>
                              <thead>
                                <tr>
                                  <th>Date</th>
                                  <th>Attendance</th>
                                  <th>Per class fee</th>
                                  <th>Tutor</th>
                                </tr>
                              </thead>
                              <tbody>
                                {!isAttendanceLoading ? (
                                  <>
                                    {attendanceList?.length > 0 ? (
                                      <>
                                        {attendanceList?.map(
                                          (
                                            attendanceItem,
                                            attendanceItemIndex
                                          ) => {
                                            return (
                                              <tr
                                                key={`atten${attendanceItemIndex}`}
                                              >
                                                <td>{attendanceItem?.date}</td>
                                                <td>
                                                  {attendanceItem?.class_type}
                                                </td>
                                                <td>
                                                  {
                                                    attendanceItem?.fees_for_parent
                                                  }
                                                </td>
                                                <td>
                                                  {
                                                    attendanceItem?.tutorData
                                                      ?.first_name
                                                  }
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )}
                                      </>
                                    ) : (
                                      <tr>
                                        <td colSpan={4}>No Attendance found</td>
                                      </tr>
                                    )}
                                  </>
                                ) : (
                                  <tr>
                                    <td colSpan={4}>Please wait...</td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                            <div className="d-flex justify-content-between">
                              <div>₹ {dataList?.data?.monthly_fee}</div>
                              <div>₹ {amountConsumed}</div>
                              <div>
                                ₹{" "}
                                {dataList?.invoiceData?.total_paid ? (
                                  <>
                                    {dataList?.invoiceData?.total_paid >=
                                    amountConsumed
                                      ? dataList?.invoiceData?.total_paid -
                                        amountConsumed
                                      : 0}
                                  </>
                                ) : (
                                  0
                                )}
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row className="mt-5">
                          <Col md="6">
                            <div>
                              Balance :{" "}
                              {dataList?.total_amount -
                                dataList?.invoiceData?.total_paid}
                            </div>
                            <div>
                              Unallocated Sessions:{" "}
                              {dataList?.data?.number_of_session -
                                dataList?.data?.sessionCompleted}
                            </div>
                            <div>
                              Usually pays by:{" "}
                              {dataList?.lastPayment?.pay_mode ||
                                "Not Paid Yet"}
                            </div>
                            {/* <Button color="primary" className="mt-2">View Full History</Button> */}
                          </Col>
                          <Col md="6">
                            <div>
                              Available Balance: ₹{" "}
                              {dataList?.invoiceData?.total_paid ? (
                                <>
                                  {dataList?.invoiceData?.total_paid >=
                                  amountConsumed
                                    ? dataList?.invoiceData?.total_paid -
                                      amountConsumed
                                    : 0}
                                </>
                              ) : (
                                0
                              )}
                            </div>
                            <div>
                              Number of Payments:{" "}
                              {dataList?.invoiceData?.number_of_payments}
                            </div>
                            <div>
                              Total Paid: ₹{" "}
                              {dataList?.invoiceData?.total_paid || 0}
                            </div>
                          </Col>
                        </Row>
                      </Container>
                    </div>

                    <div className="mt-2">
                      {!invTableLoading && (
                        <Table
                          className="align-items-center table-flush"
                          responsive
                        >
                          <thead className="thead-light">
                            <tr>
                              <th>S.No</th>
                              <th scope="col">Date</th>
                              <th scope="col">Number</th>
                              <th scope="col">Class</th>
                              <th scope="col">Amount </th>
                              <th scope="col">Remaining</th>
                              <th scope="col">Status</th>
                            </tr>
                          </thead>

                          <tbody>
                            {invvoiceList?.length > 0 ? (
                              <>
                                {invvoiceList?.map((invoice, invoiceIndex) => {
                                  console.log("check--------", invoice);
                                  return (
                                    <tr key={`invoice${invoiceIndex}`}>
                                      <td>{invoiceIndex + 1}</td>
                                      <td>
                                        {moment(invoice?.createdAt).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </td>
                                      <td>{invoice?.invoice_number}</td>
                                      <td>{invoice?.class.name}</td>
                                      <td>{invoice?.total_amount}</td>
                                      <td>{invoice?.due_amount}</td>
                                      <td>{invoice?.status}</td>
                                    </tr>
                                  );
                                })}
                              </>
                            ) : (
                              <tr>
                                <td colSpan={10} className="text-center py-4">
                                  No Invoices Found
                                </td>
                              </tr>
                            )}
                            {/* <tr className="h-30vh">
                          <td>10/03/2024</td>
                          <td>
                            <span> INV- 10 5120.00</span>
                            <p>1 month</p>
                          </td>
                          <td >  Balance <span style={{ backgroundColor: "green", padding: "2px", color: "white", borderRadius: "20px" }}>
                            paid     </span></td>

                          <td>  ₹ 45000  </td>
                          <td>

                            <Progress
                              className="my-2"
                              value="80"
                              style={{ height: "25px" }}
                            >
                              85%
                            </Progress>
                          </td>
                        </tr> */}
                          </tbody>
                        </Table>
                      )}

                      {/* <Table className="align-items-center table-flush mt-4" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Student Fee</th>
                        <th scope="col"> Date of parent Recieved</th>
                        <th scope="col">Tenure

                        </th>
                        <th scope="col">Total Fee </th>
                        <th scope="col">total Sessions</th>
                        <th scope="col">Total Salary</th>
                        <th scope="col">Gross margin</th>

                      </tr>
                    </thead>

                    <tbody>
                      <tr className="h-30vh">
                        <td>  ₹ 2000</td>
                        <td> 19- mar- 2024</td>

                        <td>

                          <Progress
                            className="my-2"
                            value="80"
                            style={{ height: "25px" }}
                          >
                            85%
                          </Progress>
                        </td>

                        <td>14100</td>

                        <td>60 sessions of 1 hour  </td>
                        <td>Aadil khan 34000/-  ₹  </td>
                        <td>₹ 1500 30% </td>
                      </tr>
                    </tbody>
                  </Table> */}
                    </div>
                  </div>
                </div>
              )}
            </CardBody>
          </Card>
        </Container>
      ) : (
        <Container className=" py-7">
          <Card className="shadow mt-1">
            <CardBody className="p-1">
              <Row>
                <Col
                  md={12}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "row",
                  }}
                >
                  <spna>
                    <i
                      class="fa-solid fa-triangle-exclamation"
                      style={{
                        color: "red",
                        fontSize: "20px",
                        marginRight: "5px",
                      }}
                    ></i>
                  </spna>
                  No Data Found
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      )}
    </>
  );
};

export default ViewCreditMapping;
